import classnames from 'classnames';

import ProductGallery from '@/components/ProductGallery';

import { Product } from '../../types/product';

import styles from './styles.module.scss';

interface ProductImagesProps {
  isProductSold: boolean;
  product: Product;
  isMobile: boolean;
  isOnSale: boolean;
  isClassics: boolean;
  handleGalleryOpenChange: (isOpen: boolean) => void;
}

/**
 * Product page gallery component
 * @param props
 * @returns
 */
export const ProductImages = (props: ProductImagesProps) => {
  const {
    isProductSold,
    product,
    isMobile,
    isOnSale,
    isClassics,
    handleGalleryOpenChange,
  } = props;

  const { images, thumbnail, title } = product;

  return (
    <div
      className={classnames(styles.leftColWrapper, {
        [styles.disabled]: isProductSold,
      })}
    >
      <div className={styles.galleryContainer}>
        <ProductGallery
          images={images}
          title={title}
          thumbnail={thumbnail}
          isMobile={isMobile}
          onOpenChange={handleGalleryOpenChange}
          status={product.status}
          isOnSale={isOnSale}
          isClassic={isClassics}
        />
      </div>
    </div>
  );
};
